<template>
  <div class="percent-input">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PercentageInput'
}
</script>

<style scoped>
.percent-input {
  position: relative;
  width: 100%;
}

.percent-input ::v-deep .vs-con-input {
  position: relative;
}

.percent-input ::v-deep .vs-con-input::after {
  content: '%';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 15px;
  font-weight: 600;
  color: #111111;
  pointer-events: none;
  line-height: 1;
  z-index: 2;
}

.percent-input ::v-deep .vs-inputx,
.percent-input ::v-deep input {
  padding-right: 2rem !important;
}
</style>
